export default "__VITE_ASSET__BFF1MCGu__"